/**
 * The agency's money calendar: every client's paychecks and deal payments on
 * one timeline, with the agency's fee beside each (shared/moneyCalendar.ts).
 *
 * Reads what the athlete's own calendar reads — active playing contracts,
 * signed deals, recorded income, and the first regular-season game from the
 * calendar — for every client in the book at once, then runs the same rule
 * per client so the two screens can never disagree. Amounts here are the
 * agency's own records, so nothing is withheld; `amount_shared` only decides
 * what the athlete sees.
 */

import { pb, escapeFilterValue } from '../lib/pocketbase'
import { ensureUserAgency } from '../utils/ensureAgency'
import { loadAgencyMoneyCalendar, type AgencyMoneyCalendar } from '../shared/agencyMoney'

export type { AgencyMoneyItem, AgencyMoneyGap, AgencyMissedMoney, FigureCheck, AgencyMoneyCalendar } from '../shared/agencyMoney'

/**
 * @param clientIds Only these clients (the page's work view), or null for the whole book.
 */
export async function getAgencyMoneyCalendar(clientIds: string[] | null = null, daysAhead = 120): Promise<AgencyMoneyCalendar> {
  const agencyId = await ensureUserAgency()
  return loadAgencyMoneyCalendar(
    (collection, filter, fields, sort) => pb.collection(collection).getFullList({ filter, fields, ...(sort ? { sort } : {}) }) as Promise<any[]>,
    `agency_id = "${escapeFilterValue(agencyId)}"`,
    clientIds,
    daysAhead,
  )
}
